import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSuperState } from 'hooks';

type RecoverUsernameFormProps = {
    loading: boolean;
    onBack: () => void;
    onError: (msg: string) => void;
    onSubmit: (email: string) => void;
};

export const RecoverUsernameForm = (props: RecoverUsernameFormProps) => {

    const { loading, onBack, onError, onSubmit } = props;

    const { formatMessage } = useIntl();

    const [state, setState] = useSuperState({
        email: '',
        emailError: '',
        touched: false
    });

    const { email, emailError, touched } = state;

    const EMAIL_REGEX = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

    const validate = (): boolean => {

        if (!email.trim()) {

            setState({ emailError: formatMessage({ id: 'you_have_not_entered_an_e_mail.41b980e7', defaultMessage: 'You have not entered an e-mail.' }) || 'You have not entered an e-mail.', touched: true });
            onError(formatMessage({ id: 'you_have_not_entered_an_e_mail.41b980e7', defaultMessage: 'You have not entered an e-mail.' }) || 'You have not entered an e-mail.');
            return false;

        }
        if (!EMAIL_REGEX.test(email.trim())) {

            setState({ emailError: formatMessage({ id: 'please_enter_a_valid_email_address.96947e30', defaultMessage: 'Please enter a valid email address.' }) || 'Please enter a valid email address.', touched: true });
            onError(formatMessage({ id: 'please_enter_a_valid_email_address.96947e30', defaultMessage: 'Please enter a valid email address.' }) || 'Please enter a valid email address.');
            return false;

        }
        setState({ emailError: '' });
        onError('');
        return true;

    };

    const handleSubmit = () => {

        if (validate()) {

            onSubmit(email.trim());

        }

    };

    const handleKeyDown = (e: React.KeyboardEvent) => {

        if (e.key === 'Enter') {

            e.preventDefault();
            handleSubmit();

        }

    };

    return (
        <>
            <img
                alt={formatMessage({ id: 'gmetrix.a4da7596', defaultMessage: 'GMetrix' })}
                className="login-card-logo d-block mx-auto"
                src="https://content.gmetrix.net/images/GMetrix/GMetrix-Logo-RGB.png"
            />
            <div className="login-card-logo-text text-center mb-1">
                {<FormattedMessage defaultMessage="Skills Management System" id="skills_management_system.ee6cd159" /> || 'Skills Management System'}
            </div>
            <div className="login-card-title text-center fw-semibold mb-1">
                {<FormattedMessage defaultMessage="Forgot your username?" id="forgot_your_username.a27e4f4a" /> || 'Forgot your username?'}
            </div>
            <div className="login-card-subtitle text-center mb-3">
                {<FormattedMessage defaultMessage="Enter your email address" id="enter_your_email_address.b67f6848" /> || 'Enter your email address'}
            </div>

            <GMetrixInput
                onChange={e => {

                    setState({ email: e.target.value, emailError: '' }); onError('');

                }}
                autoComplete="off"
                label={formatMessage({ id: 'email.5cbb5845', defaultMessage: 'Email', description: 'Formulario' }) || 'Email'}
                onKeyDown={handleKeyDown}
                type="text"
                validType={touched && emailError ? 'invalid' : undefined}
                value={email}
            />

            <GMetrixButton
                className="login-sign-in-btn w-100 mt-3"
                disabled={loading || !email.trim()}
                onClick={handleSubmit}
            >
                {loading ? (<FormattedMessage defaultMessage="Sending…" id="sending.6d6318a4" /> || 'Sending\u2026') : (<FormattedMessage defaultMessage="Send Email" id="send_email.89cfc1bd" /> || 'Send Email')}
            </GMetrixButton>

            <div className="text-center mt-3">
                <a className="login-form-link" onClick={onBack}>
                    <i aria-hidden="true" className="fa-solid fa-arrow-left me-1" />
                    {<FormattedMessage defaultMessage="Back to sign in" id="back_to_sign_in.f5cb09eb" /> || 'Back to sign in'}
                </a>
            </div>
        </>
    );

};
